import { G_POS_VERSION, MQTT_URL } from "./constants";
import ReactDOM from "react-dom";
import ModalContent from "components/modal";
import i18n from "i18n";
import { HOTPOT_SOUP_GROUP_4_CODE, HOTPOT_SOUP_2_CODE } from "constants/index";

export const checkGPosVersion = (currentVersion) => {
  if (!currentVersion) return false;
  if (!G_POS_VERSION) return true;
  const [a, b, c] = currentVersion.split(".");
  const [d, e, f] = G_POS_VERSION?.split(".");

  if (a < d) {
    return false;
  }
  if (a > d) return true;
  if (a === d) {
    if (b < e) return false;
    if (b > e) return true;
    if (b === e) {
      if (c < f) return false;
      else return true;
    }
  }
};

export const networkWarningModal = () => {
  let closeModal;
  const showModal = () => {
    const div = document.createElement("div");
    document.body.appendChild(div);

    closeModal = () => {
      ReactDOM.unmountComponentAtNode(div);
      document.body.removeChild(div);
    };

    ReactDOM.render(
      <ModalContent
        // icon={icon_no_internet}
        modalIsOpen
        title={<div>{i18n.t("textTitleNoInternet")}</div>}
        titleConfirm={i18n.t("textReload")}
        isShowBtnCancel={false}
        onConfirm={() => {
          console.log("lwlwlwlwlw", "");
          closeModal();
        }}
        content={i18n.t("textContentNoInternet")}
        error={""}
      />,
      div
    );
  };

  return [showModal, closeModal];
};

export const convertMillisecondsToLocalTime = (ms) => {
  const date = new Date(ms); // ms = timestamp (milliseconds since epoch)
  const hours = date.getHours();
  const minutes = date.getMinutes();

  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(hours)}:${pad(minutes)}`;
};

export const checkHotpotSoupMenu = (item) => {
  return [HOTPOT_SOUP_2_CODE, HOTPOT_SOUP_GROUP_4_CODE].includes(
    item?.["group-type"]
  );
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
  }).format(amount);
};

export const getValuePramsHotpotBF = (data) => {
  if (typeof data !== "string") return [false, undefined];

  const values = data.split(";").map((item) => {
    const parts = item.split(":").map((value, index) => {
      value = value.trim();
      return index === 0 || index === 2
        ? Number(value)
        : index === 1
        ? value === "true"
          ? true
          : value === "false"
          ? false
          : undefined
        : value;
    });
    return parts;
  });

  if (
    !values.every(
      (group) =>
        group.length === 3 &&
        typeof group[0] === "number" &&
        // group[0] >= 1 &&
        typeof group[1] === "boolean" &&
        typeof group[2] === "number"
    )
  )
    return [false, undefined];

  if (new Set(values.map((group) => group[0])).size !== values.length)
    return [false, undefined];

  return [true, values];
};

export const webEventExtraParams = (data) => {
  return {
    id_restaurant: data?.restaurantCode || data?.["restaurant-code"],
    table_number: data?.["table-name"],
    qr_code: data?.qrCode
      ? `${data.qrCode}__${data?.restaurantCode || data?.["restaurant-code"]}`
      : "",
    tc_nguoi_lon: data?.["adult-count"] || "0",
    tc_tre_em: data?.["child-count"] || "0",
    brand_name: data?.["brand-name"] || "",
  };
};
